import React from "react";
import { Select } from "@pd/pd-ui-kit";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormField from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/sections/FormField";
import { useGetPositionsForSelect } from "~/hooks/useGetPositionsForSelect";
import {
  IEmployeeProfileForm,
  TSelectOption,
} from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";

type TPositionsSelect = ReturnType<typeof useGetPositionsForSelect>;

interface IPositionSelectFieldProps {
  index: number;
  control: Control<IEmployeeProfileForm>;
  options: TPositionsSelect["positions"];
  onSearch: TPositionsSelect["searchText"];
  onPopupScroll: TPositionsSelect["intersectionObserver"];
  disabled?: boolean;
  allowClear?: boolean;
  placeholder?: string;
  onPositionChange: (value: TSelectOption) => void;
}

const PositionSelectField = ({
  index,
  control,
  options,
  onSearch,
  onPopupScroll,
  disabled,
  allowClear,
  placeholder,
  onPositionChange,
}: IPositionSelectFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormField label={t("employee.namePosition")}>
      <Controller
        name={`positions.${index}.position`}
        control={control}
        render={({ onChange, value, onBlur }) => (
          <Select
            labelInValue
            showSearch
            allowClear={allowClear}
            placeholder={placeholder}
            value={value?.value ? value : undefined}
            options={options}
            filterOption={false}
            onBlur={onBlur}
            onSearch={onSearch}
            onPopupScroll={onPopupScroll}
            onChange={(val) => {
              const next = (val ?? null) as TSelectOption;
              onChange(next);
              onPositionChange(next);
            }}
            disabled={disabled}
          />
        )}
      />
    </FormField>
  );
};

export default PositionSelectField;
